import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { SUPPORTED_LANGS } from '@/i18n';

export function useLocale() {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const currentLang = lang && SUPPORTED_LANGS.includes(lang) ? lang : i18n.language || 'en';

  const localePath = useCallback((path) => {
    return `/${currentLang}${path}`;
  }, [currentLang]);

  const switchLanguage = useCallback((newLang) => {
    if (!SUPPORTED_LANGS.includes(newLang)) return;
    i18n.changeLanguage(newLang);
    // Replace the language prefix in the current URL
    const pathWithoutLang = location.pathname.replace(/^\/[a-z]{2}/, '') || '/';
    navigate(`/${newLang}${pathWithoutLang}${location.search}${location.hash}`, { replace: true });
  }, [i18n, navigate, location]);

  return { lang: currentLang, localePath, switchLanguage };
}
